<template>
<div class="fondo_transparente">
  <div class="ventana_modal">
    <div class="X_cerrar" @click="cerrar">&ltrif;</div>
    <div class="ingreso">
      <div class="tituloGestion">Gestión de colecciones</div>
    </div>
    <div class="container">
      <div class="Col-1"
        @click="routeToGetCol(coleccion)"
        v-for="coleccion in colecciones" :key="coleccion.idCol">
          <p id="textoCol">{{coleccion.nomCol}}</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MenuColecciones',
  methods: {
    cerrar () {
      this.$router.go(-1)
    },
    routeToGetCol (coleccion) {
      this.$router.push(coleccion.codCol)
    }
  },
  computed: {
    ...mapState(['colecciones'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.ventana_modal{
  width: 70vw;
  height: 70vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  display: grid;
  grid-template-rows: 35% 65%;
  justify-items: center;
  align-items: space-around;
}
.ingreso{
  background-color: rgba(10, 90, 140, 0.5);
  justify-self: stretch;
  display:grid;
}
.tituloGestion{
  justify-self: left;
  align-self: center;
  margin-left: 8%;
  font-size: 45px;
  font-weight: lighter;
  padding-bottom: 5px;
  /* padding-top: 10%; */
  color: var(--na);
  /* color:rgb(251, 194, 88); */
  /* text-shadow: rgb(5, 5, 5) 4px 4px 3px; */
}

.X_cerrar{
  font-size: 35px;
  position: absolute;
  right: 10px;
  color:white;
  top: 10px;
  padding-bottom: 2px;
  width: 35px;
  height: 35px;
  /* border-radius: 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(1, 117, 163, 0);
  transition: all 0.5s ease-out;
  /* border:2px solid darkorange; */
}
.X_cerrar:hover{
  /* border-color: white; */
  /* background-color: rgb(253, 242, 205, 0.2); */
  border: solid 1px rgba(10, 90, 140, 0.8);
  transform: translateX(-6px);
}
.container {
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  color:white;
  font-size: 1.2rem;
  font-weight: lighter;
  justify-content: center;
  align-items: auto;
  grid-gap:2px;
  margin-top: 2px;
}
.Col-1 {
  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: 2px;
  padding-left: 15px;
  padding-right: 15px;
  background-color:rgba(10, 90, 140, 0.7);
  font-family: SegoeL;
  cursor: pointer;
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;

  text-align: center;
}
#Col {
  border: solid rgba(0, 75, 105, 0.7) 1px;
}
.Col-1:hover {
  border-color: rgba(1, 117, 163, 0.95);
  background-color:rgba(10, 90, 140, 0.90);
}
#textoCol {
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.Col-1:hover #textoCol{
  transform: translateY(-6px);
}
p {
  text-decoration: none;
}
li{
  list-style: none;
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 85vw;
    height: 80vh;
    display: flex;
    flex-direction: column;
  }
  .ingreso{
    height: 100%;
  }
  .tituloGestion{
    justify-self: center;
    margin-left: 0;
    font-size: 28px;
    padding-top: 15%;
    font-size: 30px;
  }
  .container{
    display: flex;
    flex-direction: column;
    font-size: 1.2rem;
  }
  .Col-1 {
    padding-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
  }
  p {
    margin: 12px;
  }
}
</style>
